import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import LabelDesigner from './LabelDesigner';

// eslint-disable-next-line no-unused-vars
/* global jQuery */

// Current date and user information
const CURRENT_UTC_DATE = '2025-04-22 14:13:58';
const CURRENT_USER = 'labelgo';

// Function to update cart thumbnails
const updateCartThumbnails = () => {
    const cartItems = document.querySelectorAll('.woocommerce-cart-form__cart-item');
    cartItems.forEach(item => {
        const itemKey = item.getAttribute('data-cart-item-key');
        const labelImage = localStorage.getItem(`cart_label_${itemKey}`);
        if (labelImage) {
            const thumbnail = item.querySelector('.product-thumbnail img');
            if (thumbnail) {
                thumbnail.src = labelImage;
                thumbnail.style.maxWidth = '100px';
            }
        }
    });
};

// Function to add data attributes to cart items
const addCartItemKeys = () => {
    const cartItems = document.querySelectorAll('.woocommerce-cart-form__cart-item');
    cartItems.forEach(item => {
        const inputElement = item.querySelector('input[name^="cart["]');
        if (inputElement) {
            const matches = inputElement.name.match(/cart\[(.*?)\]/);
            if (matches && matches[1]) {
                item.setAttribute('data-cart-item-key', matches[1]);
            }
        }
    });
};

// Observer to watch cart updates
const setupCartObserver = () => {
    const observer = new MutationObserver(() => {
        addCartItemKeys();
        updateCartThumbnails();
    });

    const cartContainer = document.querySelector('.woocommerce-cart-form');
    if (cartContainer) {
        observer.observe(cartContainer, {
            childList: true,
            subtree: true
        });
    }

    return observer;
};

// Function to update cart design previews
const updateCartDesignPreviews = () => {
    const cartItems = document.querySelectorAll('.woocommerce-cart-form__cart-item');
    cartItems.forEach(item => {
        const designIdMatch = item.querySelector('.product-name')?.textContent.match(/\[CUSTOM_LABEL_ID:(.*?)\]/);
        if (designIdMatch) {
            const designId = designIdMatch[1];
            const designData = localStorage.getItem(`label_design_${designId}`);
            const imageData = localStorage.getItem(`label_image_${designId}`);

            if (designData && imageData) {
                // Update thumbnail
                const thumbnail = item.querySelector('.product-thumbnail img');
                if (thumbnail) {
                    thumbnail.src = imageData;
                    thumbnail.style.maxWidth = '100px';
                }

                // Add design details
                const parsedData = JSON.parse(designData);
                const detailsContainer = document.createElement('div');
                detailsContainer.className = 'label-design-details';
                detailsContainer.innerHTML = `
                    <div class="design-info">
                        <p><strong>Design Details:</strong></p>
                        <p>Dimensions: ${parsedData.dimensions.width}x${parsedData.dimensions.height}${parsedData.dimensions.unit}</p>
                        <p>Created: ${parsedData.createdAt}</p>
                        <p>Created by: ${parsedData.createdBy}</p>
                    </div>
                `;

                const existingDetails = item.querySelector('.label-design-details');
                if (!existingDetails) {
                    item.querySelector('.product-name').appendChild(detailsContainer);
                }
            }
        }
    });
};

// Set up event listeners
document.addEventListener('DOMContentLoaded', () => {
    addCartItemKeys();
    updateCartThumbnails();
    updateCartDesignPreviews();

    // eslint-disable-next-line no-unused-vars
    const observer = setupCartObserver();

    // Listen for WooCommerce cart update events
    if (window.jQuery) {
        window.jQuery(document.body).on('updated_cart_totals wc_fragments_refreshed', () => {
            addCartItemKeys();
            updateCartThumbnails();
            updateCartDesignPreviews();
        });
    }
});

// Start React application
const root = ReactDOM.createRoot(document.getElementById('cld-label-designer-root'));
root.render(
    <React.StrictMode>
        <LabelDesigner currentUser={CURRENT_USER} currentDate={CURRENT_UTC_DATE} />
    </React.StrictMode>
);

// Listen for cart fragment refresh events
document.body.addEventListener('wc_fragment_refresh', () => {
    setTimeout(() => {
        addCartItemKeys();
        updateCartThumbnails();
        updateCartDesignPreviews();
    }, 500);
});

// Function to clean up design data
const cleanupDesignData = () => {
    const now = new Date().getTime();
    const oneDay = 24 * 60 * 60 * 1000; // 24 hours

    Object.keys(localStorage).forEach(key => {
        if (key.startsWith('label_design_') || key.startsWith('label_image_') || key.startsWith('cart_label_')) {
            const timestamp = parseInt(key.split('_')[2]);
            if (now - timestamp > oneDay) {
                localStorage.removeItem(key);
            }
        }
    });
};

// Clean up localStorage on page load and unload
window.addEventListener('load', cleanupDesignData);
window.addEventListener('beforeunload', () => {
    // Clean up designs not in cart
    const cartItems = document.querySelectorAll('.woocommerce-cart-form__cart-item');
    const activeDesignIds = new Set();

    cartItems.forEach(item => {
        const designIdMatch = item.querySelector('.product-name')?.textContent.match(/\[CUSTOM_LABEL_ID:(.*?)\]/);
        if (designIdMatch) {
            activeDesignIds.add(designIdMatch[1]);
        }
    });

    Object.keys(localStorage).forEach(key => {
        if (key.startsWith('label_design_')) {
            const designId = key.split('label_design_')[1];
            if (!activeDesignIds.has(designId)) {
                localStorage.removeItem(key);
                localStorage.removeItem(`label_image_${designId}`);
            }
        }
    });
});

// Error handling and reporting
window.addEventListener('error', (event) => {
    // Silent error handling
});

// Debug mode console messages
if (process.env.NODE_ENV === 'development') {
    // Silent debug mode
}